import * as React from 'react'

import { User_user } from 'main/gql/user'
import { CaretDownIcon, CaretUpIcon } from 'main/ui'
import { Avatar, CaretIconContainer, Container } from './Profile.styles'

interface IProps {
  menuActive: boolean
  user: User_user
  onClickMenu: () => void
}

function Profile(props: IProps) {
  const { menuActive, user, onClickMenu } = props

  return (
    <Container onClick={onClickMenu}>
      <Avatar src={`${user.avatarUrl}-/format/auto/-/scale_crop/50x50/`} />
      <CaretIconContainer>{menuActive ? <CaretUpIcon /> : <CaretDownIcon />}</CaretIconContainer>
    </Container>
  )
}

export default React.memo(Profile)
